import styled from "styled-components";

export const StyledTableColumnsSelectionContainer = styled.div`
    padding-right: 8px;
    display: inline-flex;
    align-items: center;
`;
